import { putUser, putUserRegistry, putUserRv2 } from "@rubi/api-generated";

import { apiReportClient } from "@/api";
import { SUB_PERMISSION_KEYS } from "@/components/UserManagement/permissionTree";
import { Permission } from "@/components/UserManagement/types";

export const grantPermissions = async (
  userId: string,
  permissions: Permission[],
): Promise<void> => {
  for (const permission of permissions) {
    if (SUB_PERMISSION_KEYS.has(permission)) {
      await apiReportClient
        .addOrgUserPermission(userId, permission)
        .catch(console.error);
      continue;
    }

    switch (permission) {
      case Permission.ALERT:
        await putUser({ body: { id: userId } }).catch(console.error);
        await apiReportClient
          .updateAppAccess(userId, "alert", true)
          .catch(console.error);
        break;
      case Permission.REPORT:
        await apiReportClient.putReportUser(userId).catch(console.error);
        await apiReportClient
          .updateAppAccess(userId, "report", true)
          .catch(console.error);
        break;
      case Permission.REPORT_V2:
        await putUserRv2({ body: { id: userId } }).catch(console.error);
        await apiReportClient
          .updateAppAccess(userId, "report_v2", true)
          .catch(console.error);
        break;
      case Permission.REGISTRY:
        await putUserRegistry({ body: { id: userId } }).catch(console.error);
        await apiReportClient
          .updateAppAccess(userId, "registry", true)
          .catch(console.error);
        break;
      case Permission.CAMERA_REGISTRY:
        await apiReportClient
          .updateAppAccess(userId, "camera_registry", true)
          .catch(console.error);
        break;
      case Permission.INTEL:
        await apiReportClient
          .updateAppAccess(userId, "intel", true)
          .catch(console.error);
        break;
      case Permission.MESSAGE:
        await apiReportClient
          .updateAppAccess(userId, "message", true)
          .catch(console.error);
        break;
      case Permission.CONNECT:
        await apiReportClient
          .addOrgUserPermission(userId, permission)
          .catch(console.error);
        break;
      default:
        break;
    }
  }
};
